import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetCertificationQuery } from "@/redux/service";
import CertificationAdmin from "@/features/certifications/admin";
import AdminSkeleton from "@/features/certifications/admin/components/AdminSkeleton";
import { ADMIN_TABS } from "@/domains/certifications/routes";

const CertificationAdminPage = () => {
  const { slug } = useParams();
  const [, setSearchParams] = useSearchParams();
  const { data: certification, isError } = useGetCertificationQuery(
    slug ?? skipToken,
  );

  if (!slug || isError) {
    return <Navigate to="/" replace />;
  }

  if (!certification) {
    return <AdminSkeleton />;
  }

  const showInvitations = () =>
    setSearchParams({ tab: ADMIN_TABS.INVITATIONS }, { replace: true });

  return (
    <CertificationAdmin
      certification={certification}
      onShowInvitations={showInvitations}
    />
  );
};

export default CertificationAdminPage;
